import { BestellingDorpelDto, BestellingNeutDto } from "../api-models/models";
import { ModelFactory } from "./model-factory";

export class DorpelDecorator {
  public static setNumberOfSluitpotten(
    target: BestellingDorpelDto,
    count: number
  ): BestellingDorpelDto {
    target.aantalSluitpotten = count;
    if (target.sluitpotten?.length > count) {
      target.sluitpotten.splice(count);
    } else {
      const sluitpottenCount = target.sluitpotten?.length;
      for (let i = 0; i < count - sluitpottenCount; i++) {
        target.sluitpotten.push(ModelFactory.createSluitpot());
      }
    }
    return target;
  }

  public static setNumberOfNeuten(
    target: BestellingDorpelDto,
    count: number
  ): BestellingDorpelDto {
    target.aantalNeuten = count;
    if (target.neuten.length > count) {
      if(count > 1) {
        let length = target.neuten.length;
        let extra = length - count;
        target.neuten.splice(length - extra - 1, extra);
      } else if (count === 1) {
        target.neuten.splice(1);
      }
    } else {
      const neutenCount = target.neuten.length;
      const diff = count - neutenCount;
      for (let i = 0; i < diff; i++) {
        target.neuten.splice(target.neuten.length - 1, 0, ModelFactory.createNeut())
      }
    }
    return target;
  }
}
